import { TABLE_ROWS } from 'common/constants';
import { DataAccessPoliciesOrderBy } from 'common/types/globalTypes';
import { OrderDirection, SortOrder } from 'common/utils/commonTypes';
import {
  DataAccessPolicies,
  DataAccessPoliciesVariables,
} from 'settings/account/dataAccessPolicy/list/__generated__/DataAccessPolicies';

type OrderLookup = {
  [direction in OrderDirection]: DataAccessPoliciesOrderBy[];
};

const orderByMap = new Map<string, OrderLookup>([
  [
    'name',
    {
      [OrderDirection.ASC]: ['NAME_ASC'],
      [OrderDirection.DESC]: ['NAME_DESC'],
    },
  ],
  [
    'description',
    {
      [OrderDirection.ASC]: ['DESCRIPTION_ASC'],
      [OrderDirection.DESC]: ['DESCRIPTION_DESC'],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder) => {
  const orderByArray: DataAccessPoliciesOrderBy[] | undefined = [
    'NAME_ASC',
    'PRIMARY_KEY_ASC',
  ];
  if (!sort) return orderByArray;

  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return Array.from(new Set([...(orderBy ? orderBy : []), ...orderByArray]));
};
export const onHandleSearch = (
  showMore: boolean,
  dataAccessPolicies: DataAccessPolicies | undefined,
  sortOrderParam: SortOrder | undefined
) => {
  const variables: DataAccessPoliciesVariables = {
    first: TABLE_ROWS,
    after: showMore
      ? dataAccessPolicies?.dataAccessPolicies?.pageInfo.endCursor
      : undefined,
    orderBy: toOrderByVariable(sortOrderParam),
  };
  return {
    queryVariables: variables,
  };
};
